export type TenantUsersStatusFilter = 'all' | 'enabled' | 'disabled';

export type TenantUsersFilterState = {
  search: string;
  status: TenantUsersStatusFilter;
};

export function isTenantUsersStatusFilter(
  value: string,
): value is TenantUsersStatusFilter {
  return value === 'all' || value === 'enabled' || value === 'disabled';
}

export function parseTenantUsersFilterFromSearchParams(
  searchParams: URLSearchParams,
): TenantUsersFilterState {
  const search = searchParams.get('search')?.trim() ?? '';
  const statusRaw = searchParams.get('status')?.trim() ?? '';

  return {
    search,
    status: isTenantUsersStatusFilter(statusRaw) ? statusRaw : 'all',
  };
}

export function buildTenantUsersSearchParams({
  searchInput,
  status,
}: {
  searchInput: string;
  status: TenantUsersStatusFilter;
}): URLSearchParams {
  const params = new URLSearchParams();

  const trimmedSearch = searchInput.trim();
  if (trimmedSearch !== '') {
    params.set('search', trimmedSearch);
  }

  if (status !== 'all') {
    params.set('status', status);
  }

  return params;
}
